import React from 'react';

import Icon from './components/Icon';

const IconPause = (props: any) => {
	return <Icon id="mpa-pause" handle={props.handle} {...props} />;
};

export default IconPause;
